import * as Yup from 'yup';

export interface OrbitSpecialConditionValues {
    hasSpecialCondition: boolean;
    specialCondition: string;
    observations: string;
}

export const initialValues: OrbitSpecialConditionValues = {
    hasSpecialCondition: false,
    specialCondition: '',
    observations: '',
};

export const validationSchema = Yup.object({
    specialCondition: Yup.string().when('hasSpecialCondition', {
        is: true,
        then: () =>
            Yup.string().required('La condición especial es obligatoria'),
    }),
    observations: Yup.string().when('hasSpecialCondition', {
        is: true,
        then: () =>
            Yup.string()
                .required(
                    'Las observaciones especiales del ciudadano son obligatorias'
                )
                .max(
                    500,
                    'El campo observaciones debe tener 500 caracteres como máximo'
                ),
    }),
});
